import { useEffect, useRef } from "react";

const usePooling = (callback, delay) => {
  const savedCallback = useRef();
  useEffect(() => {
    savedCallback.current = callback;
  }, [callback]);
  useEffect(() => {
    const handler = (...args) => {
      if (typeof savedCallback.current === 'function') {
        savedCallback.current(...args);
      }
    };

    if (delay !== null) {
      const id = setInterval(handler, delay);
      return () => clearInterval(id);
    }
  }, [delay, callback]);
};

export default usePooling;
